import { render, staticRenderFns } from "./map.vue?vue&type=template&id=22b24e7a&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"
import style0 from "./map.vue?vue&type=style&index=0&id=22b24e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b24e7a",
  null
  
)

export default component.exports